<template>
  <div class="h-fill bg-f3f">
    <div class="pd-10">
      <div class="bdr-5 display-flex justify-content-space-between pd-20"
           style="background-image: linear-gradient(to right,#DCF0F5,#FFFFFF);box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
        <div class="align-items-center">
          <div>
            <img :src="userInfo.userAvatar" class="w-40 h-40 pd-3 bg-white bdr-circular"/>
          </div>
          <div class="fs-20 mg-l-10">{{ userInfo.userNickname }}</div>
        </div>
        <div class="text-align-center display-flex align-items-center">
          <div class="fs-14 c-app-green">{{ userInfo.fileCount }}</div>
          <div class="c-777 fs-12 mg-l-10">个卡牌资源</div>
        </div>
      </div>
    </div>
    <div class="pd-l-10 pd-r-10" v-if="tabList.length > 1">
      <van-tabs :ellipsis="false" v-model="groupId" color="#28BEA0" class="bdr-5">
        <van-tab v-for="tab in tabList" :title="tab.name" :name="tab.id"></van-tab>
      </van-tabs>
    </div>
    <div class="pd-l-5 pd-r-5">
      <div v-for="(card,index) in cardList" v-if="groupId === '0' || card.groupId === groupId" class="pd-5">
        <card-item class="bg-f bdr-6" :card="card"></card-item>
      </div>
    </div>
  </div>
</template>

<script>
import cardItem from "@/components/cardItem.vue";
import request from '@/libs/api.request'

export default {
  name: "UserCenter",
  components: {
    cardItem,

  },
  data() {
    return {
      userId: this.$route.params.userId,
      tabList: [],
      cardList: [],
      groupId: "0",
      userInfo: {
        userNickname: "",
        userAvatar: "",
        fileCount: 0
      }
    }
  },
  watch: {
    '$route'(to, from) {
      console.log("userCenter route")
      if (this.$route.params.userId && this.userId !== this.$route.params.userId) {
        this.userId = this.$route.params.userId;
        this.getData();
      }
    }
  },
  methods: {
    getData() {
      request.request({
        url: "/card/groupListByUser",
        params: {
          userId: this.userId,
        }
      }).then((data) => {
        this.tabList = data.groupList;
      })
      request.request({
        url: "/user/otherUserInfo",
        params: {
          userId: this.userId,
        }
      }).then((data) => {
        this.userInfo = data;
      })
      request.request({
        url: "/card/getCardListWithGroupByUser",
        params: {
          userId: this.userId,
        }
      }).then((data) => {
        this.cardList = data.cardList;
      })
    }
  },
  mounted() {
    document.title = '作者主页';
    this.getData();
  }
}
</script>

<style scoped>
::v-deep .van-tab {
  font-size: 14px !important;
  font-weight: bold !important;
}
</style>